module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_3-ab06d61ddf5a8a73e9c2aab4536532eb.png";